<div class="blackout-rules-list" data-testid="blackout-rules-list">

  <div class="notification is-light is-size-7" *ngIf="!ranges?.length">
    No rules yet. Use <strong>+ Add rule</strong> to create one.
  </div>

  <div
    class="blackout-rule-row"
    *ngFor="let range of ranges; let i = index; trackBy: trackByIndex"
    [class.is-selected]="selectedIndex === i"
    [class.has-error]="!!validateRange(range)"
    [attr.data-testid]="'blackout-rule-row-' + i"
  >
    <button
      type="button"
      class="blackout-rule-row-main"
      [disabled]="disabled"
      (click)="selectRule(i)"
     data-ui-name="overnight full day" data-ui-component="blackout-hours-rules-list" data-testid="blackout-hours-rules-list-overnight-full-day">
      <div class="blackout-rule-row-title">
        <span class="tag is-small" [class.is-success]="isAllowAllDay(range)" [class.is-warning]="!isAllowAllDay(range)">
          {{ isAllowAllDay(range) ? 'Available' : 'Blocked' }}
        </span>
        <span class="blackout-rule-name">{{ chipTitles[i] }}</span>
      </div>
      <div class="blackout-rule-row-summary">{{ scheduleSummary(range) }}</div>
      <span class="tag is-light is-small" *ngIf="isOvernightRange(range)">overnight</span>
      <span class="tag is-light is-small" *ngIf="isFullDayBlackout(range)">full day</span>
    </button>
    <div class="blackout-rule-row-actions">
      <button
        type="button"
        class="button is-small"
        [disabled]="disabled"
        (click)="onDuplicate($event, i)"
        [attr.data-testid]="'blackout-rule-duplicate-' + i"
       data-ui-name="Duplicate" data-ui-component="blackout-hours-rules-list">Duplicate</button>
      <button
        type="button"
        class="button is-small is-danger is-outlined"
        [disabled]="disabled"
        (click)="onRevoke($event, i)"
        [attr.data-testid]="'blackout-rule-revoke-' + i"
       data-ui-name="Revoke" data-ui-component="blackout-hours-rules-list">Revoke</button>
    </div>
  </div>
</div>
